import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";
import { Sparkle } from "@/components/GoldOrnament";

export default function BrandMarquee() {
  const { t, isRTL } = useLang();
  const words = t.marquee.split("·").map((w) => w.trim()).filter(Boolean);

  return (
    <div className="bg-cream border-y border-sand/60 py-5 overflow-hidden" data-testid="brand-marquee">
      <Marquee speed={35} gradient={false} direction={isRTL ? "right" : "left"} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-serif text-2xl md:text-3xl text-taupe/70">
            {w}
            <Sparkle size={16} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
